import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'SETTINGS',
    entityName: 'LOGO',
});

const initialState = {
    ...crudInitialState,
    deletedLogo: {},
    deleting: false,
    saving: false,
    progress: null,
    snackBar: false,
    snackStart: false
};


const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case 'CLEAN_STATE':
            return initialState;
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        case 'LOGOS|PROGRESS':
            return { ...state, progress: action.progress, maxSize: action.maxSize, loadSize: action.loadSize, snackStart: action.snackStart };
        default:
            return state;
    }
};

export default reducer;
